export default "__VITE_ASSET__BWsagosB__"